import React from "react";
import { useState } from "react";
import UseBranchInfo from "../../../hooks/UseBranchInfo";
import "./Branch.scss";
import BranchInfo from "./BranchInfo/BranchInfo";

const Branch = () => {
  const [branchInfo, setBranchInfo, loading] = UseBranchInfo();
  const [searchBranch, setSearchBranch] = useState("");

  // console.log("Branch Info", branchInfo);

  const handleSearchBranch = (e) => {
    setSearchBranch(e.target.value);
    // console.log("searchBranch", searchBranch);
  };

  return (
    <>
      <div className="container">
        <div className="branch">
          <div className="heading_box">Branch Info</div>

          <div className="search_branch">
            <input
              type="text"
              placeholder="Type Branch Name"
              className="form-control"
              onChange={handleSearchBranch}
            />
            <div className="branch_search_icon">
              <i className="fa-solid fa-magnifying-glass m-auto"></i>
            </div>
          </div>

          <div className="row">
            {loading ? (
              <h3 className="text-center mb-5">
                Total branch: {branchInfo.length}
              </h3>
            ) : (
              <div className="text-center my-5">
                <button className="btn btn-danger w-50" type="button">
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              </div>
            )}

            {branchInfo
              .filter((val) => {
                if (branchInfo === "") {
                  return val;
                } else if (
                  val.BranchName.toLowerCase().includes(
                    searchBranch.toLowerCase().replace(/\s+/g, "")
                  )
                  // ||
                  // val.PolicyCertificateIssuingDate.toLowerCase().includes(
                  //   searchUnsetClaim.toLowerCase().replace(/\s+/g, "")
                  // )
                )
                  return val;
              })
              .map((branch) => (
                <BranchInfo
                  branch={branch}
                  key={branch.BranchCode}
                ></BranchInfo>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Branch;
